import { useTranslation } from "react-i18next";
import { ROCKETCHAT_ADMIN_URL } from "../consts/channelMap";

export default function ChatAdminPage() {
  const { t } = useTranslation("ChatAdminPage");

  return (
    <>
      <title>{t("meta.title")}</title>
      <section className="flex-1 flex flex-col">
        <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5">
          <h1 className="text-display-xs content-base-primary">{t("title")}</h1>
        </div>
        <div className="flex-1 flex flex-col radius-lg overflow-hidden">
          <iframe
            src={ROCKETCHAT_ADMIN_URL}
            className="flex-1 w-full border-0 bg-white"
            allow="clipboard-read; clipboard-write; microphone; camera; fullscreen; autoplay"
            title={t("iframeTitle")}
          />
        </div>
      </section>
    </>
  );
}
